import { Link } from "react-router-dom";

export default function AboutStrip() {
  return (
    <section className="w-full px-4 pt-14 md:px-6 md:pt-20">
      <div className="overflow-hidden rounded-lg border border-background-300/70 bg-background-50">
        <div className="grid grid-cols-1 lg:grid-cols-5">
          <div className="relative h-56 w-full lg:col-span-2 lg:h-auto">
            <img
              src="https://readdy.ai/api/search-image?query=vintage%20film%20archive%20shelves%20with%20stacked%20film%20reels%20and%20canisters%2C%20warm%20amber%20and%20crimson%20tones%2C%20nostalgic%20library%20atmosphere%2C%20soft%20window%20light%2C%20textured%20grain%2C%20editorial%20photography%2C%20no%20people&width=900&height=900&seq=about-archive-01&orientation=squarish"
              alt="电影档案室"
              title="香港三级片电影档案资料"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="flex flex-col justify-center p-6 md:p-10 lg:col-span-3">
            <span className="inline-flex w-fit items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-information-line" />
              关于本站
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              一座属于香港三级片的电影档案馆
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              本站以「电影档案」的专业视角，系统整理香港三级片（Category III）的代表作品，涵盖导演、主演、年代、类型、剧情解析与标签，
              并通过多维度分类与检索功能，帮助影迷与研究者理解这一类型片的历史脉络、创作生态与艺术价值。
            </p>
            <ul className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-3">
              <li className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-checkbox-circle-line text-primary-500" />
                结构化电影档案
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-checkbox-circle-line text-primary-500" />
                多维度分类导航
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-checkbox-circle-line text-primary-500" />
                纯资料 · 无播放下载
              </li>
            </ul>
            <div className="mt-7 flex flex-wrap gap-3">
              <Link
                to="/about"
                className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                了解更多
                <i className="ri-arrow-right-line" />
              </Link>
              <Link
                to="/search"
                className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-200"
              >
                <i className="ri-search-line" />
                立即检索
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}